import { getOneclickStartLivestreamUrl } from '../../../../../../infrastructure/utils/knovio.utils';
import { EmbedCodeLinkViewModel } from './embed-code-link.viewmodel';

export class OneclickStartLivestreamLinkViewModel extends EmbedCodeLinkViewModel {
    /* Resolved lazily so the environment configuration is read on first use, not at module import */
    protected get linkPrefix(): string {
        return getOneclickStartLivestreamUrl();
    }
}
